var customizableStepsFormManager = (function(){

    function init(){
        if(!$(".step-by-step-form-component").length) return
        currentForm = $(".step-by-step-form-component");

        //HANDLE SUBMIT
        currentForm.find("form").on("submit", function(e){
            var attachmentFieldArray = currentForm.find('input[type="file"]');
            attachmentFieldArray.each(function(index,file){
                $.each(file.files, function(index,singleFile){
                    if(singleFile.size>attachments_ENV.max_file_size_bytes){
                        e.preventDefault();
                        file.closest(".attribute-wrapper-container").classList.add("not-valid-attribute");
                    }
                })
            })
        })
        
        //HANDLE CLICK ON BUTTON TO UPLOAD FILE:
        currentForm.find(".custom-attachment-field-container button.browse-button").on("click", function(e){
            var inputField = $(this).closest(".custom-attachment-field-container").siblings('input[type="file"]');
            
            inputField.trigger('click');
        })

        //UPDATE PLACEHOLDER
        currentForm.find('input[type="file"]').on("change", function(){
            var fileName = this.files.length ? this.files[0].name : '';
            var placeholder = $(this).siblings(".custom-attachment-field-container").find("span.placeholder");

            placeholder.html(`${fileName}<i class="ml-1 mr-1 fas fa-minus-square remove-file" style="cursor:pointer"></i>`);
        })

        //HANDLE REMOVE FILE
        currentForm.on("click", ".remove-file", function(){
            var attachmentContainer = $(this).closest(".custom-attachment-field-container");
            var inputField = attachmentContainer.siblings('input[type="file"]');

            inputField.val("");

            placeholderText = attachmentContainer.find("span.placeholder").data("placeholder-text");
            attachmentContainer.find(".placeholder").text(placeholderText);

        });

        //HANDLE ANIMATION OF STEPS
        currentStep = 0;
        totalSteps = currentForm.find(".steps-container").data("total-steps")
        currentForm.find("button.go-next").on("click", function(){
            if(currentStep < totalSteps - 1){
                //SET CURRENT STEPS AS COMPLETED AND NEXT AS ACTIVE
                currentForm.find('.single-step[data-current-step-index="' + currentStep + '"]').removeClass("active");
                currentForm.find('.single-step[data-current-step-index="' + currentStep + '"]').addClass("completed");

                currentForm.find('.single-step[data-current-step-index="' + (currentStep + 1) + '"]').addClass("active");

                currentStep = currentStep + 1;
                currentForm.find(".wrapper.d-flex").css("transform","translateX(-" + (currentStep*100) + "%)");

                handleActionButtons(currentStep, totalSteps);
                handleDynamicHeight(currentStep);
            }

            //ACTIVE SUBMIT BUTTON
            
        })

         currentForm.find("button.go-prev").on("click", function(){
            if(currentStep > 0){
                //SET CURRENT STEPS AS NOTHING AND PREV AS ACTIVE
                currentForm.find('.single-step[data-current-step-index="' + currentStep + '"]').removeClass("active");
                currentForm.find('.single-step[data-current-step-index="' + (currentStep-1) + '"]').removeClass("completed");
                currentForm.find('.single-step[data-current-step-index="' + (currentStep-1) + '"]').addClass("active");

                currentStep = currentStep - 1;
                currentForm.find(".wrapper.d-flex").css("transform","translateX(-" + (currentStep*100) + "%)");

                handleActionButtons(currentStep, totalSteps);
                handleDynamicHeight(currentStep);
            }
        })

        //HANDLE DEPENDING ATTRIBUTES
        handleDynamicallyEnabledFields();
    }

    function handleDynamicallyEnabledFields(){
        currentForm.find("[data-depends-on-attribute]").each(function(){
            var currentDependingAttribute = $(this);

            var dependsOnAttributeName = currentDependingAttribute.data("depends-on-attribute");
            var dependsOnAttributeValue = currentDependingAttribute.data("depends-on-value");

            var toControlAttribute = currentForm.find("[name='" + dependsOnAttributeName + "']");

            toControlAttribute.on("change select2:select", function(event){

                var currentValue = null;
                if(toControlAttribute.attr("type") === "radio"){
                    if (toControlAttribute.is(":checked")){
                        toControlAttribute.each(function () {
                            if ($(this).is(":checked")){
                                currentValue = $(this).val();
                            }
                        });
                        handleDynamicHeight(currentStep);
                    }
                } else {
                    currentValue = toControlAttribute.val(); //TO IMPROVE <- doesn't apply to all types of attributes
                    handleDynamicHeight(currentStep);
                }
                
                if(currentValue == dependsOnAttributeValue){
                    currentDependingAttribute.removeClass("d-none");
                    if(currentDependingAttribute.find("select").length){
                        currentDependingAttribute.find("select").select2("destroy")
                        currentDependingAttribute.find("select").select2()
                    }
                    handleDynamicHeight(currentStep);

                } else {
                    currentDependingAttribute.addClass("d-none");
                    currentDependingAttribute.find("input").prop("required", false);
                    handleDynamicHeight(currentStep);
                }
            });

            toControlAttribute.trigger("change");
        })
    }

    function handleDynamicHeight(currentStep){
        currentActiveStepHeight = currentForm.find('.single-step-container[data-current-step-index="' + currentStep + '"]').outerHeight();
        
        setTimeout(() => {
            currentForm.find('.wrapper').css("height", currentActiveStepHeight + "px");
        }, 350);
        
    }

    function handleActionButtons(currentStep, totalSteps){

        //RESET
        currentForm.find("button.go-next").prop("disabled", false);
        currentForm.find("button.go-next").removeClass("disabled");
        currentForm.find("button.go-prev").prop("disabled", false);
        currentForm.find("button.go-prev").removeClass("disabled");
        
        if(currentStep + 1 == totalSteps){
            currentForm.find("button.go-next").addClass("disabled");
            currentForm.find("button.go-next").prop("disabled", true);
            currentForm.find("button.go-prev").removeClass("disabled");
            currentForm.find("button.go-prev").prop("disabled", false);
        }

        if(currentStep == 0){
            currentForm.find("button.go-next").removeClass("disabled");
            currentForm.find("button.go-next").prop("disabled", false);
            currentForm.find("button.go-prev").addClass("disabled");
            currentForm.find("button.go-prev").prop("disabled", true);
        }
    }

    return {
        init: init
    }

})(jQuery);